import { useState } from 'react'
import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'
import { convertEpochToDate, convertNumberToCurrency } from '../../../utils/utils'
import MFAccordion from '../../ui-components/MFAccordion'
import NameValueTable from '../../ui-components/NameValueTable'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'
import { mfLogoBaseUrl } from '../../../env'

export const AboutFund = () => {
  const [isAboutFundAccordionExpanded, setIsAboutFundAccordionExpanded] = useState(false)
  const { data, isin } = useMetaDataContext()
  return (
    <MFAccordion
      icon={`${mfLogoBaseUrl}${data?.fundLogo}`}
      isIconBorder={true}
      title={`About ${data?.fundDetails?.fundHouse}`}
      isExpanded={isAboutFundAccordionExpanded}
      onAccordionClick={() =>
        setIsAboutFundAccordionExpanded((isAboutFundAccordionExpandedPrev) => {
          trackEvent({
            eventName: EventNames.UserClicked,
            payload: {
              eventId: 'About_fund',
              responseName: isAboutFundAccordionExpandedPrev ? 'Collapse' : 'Expand',
              screenType: 'MF_L2',
              fundName: isin
            }
          })
          return !isAboutFundAccordionExpandedPrev
        })
      }
      isBorderTop={true}
    >
      <div className='flex flex-col pt-[8px] pb-[16px] gap-[20px]'>
        <div>
          <NameValueTable
            data={[
              { name: 'Rank (as per AUM)', value: `${data?.fundHouseMetaData?.rankAsPerAum ?? '-'}` },
              {
                name: 'Total AUM',
                value: convertNumberToCurrency({
                  amount: data?.fundHouseMetaData?.totalAum ? +data?.fundHouseMetaData?.totalAum : 0,
                  isRound: true
                })
              },
              { name: 'Launch Date', value: convertEpochToDate(data?.fundHouseMetaData?.foundedOn ?? 0) }
            ]}
            gap={8}
            groupForAccessibility
          />
        </div>
        {data?.fundHouseMetaData?.aboutUs && <div className='text-[#6A6E6E]'>{data?.fundHouseMetaData?.aboutUs}</div>}
        {/* <div>
              <Button onClick={() => null} isFullWidth buttonClassName='h-max py-2 focus:outline-none'>
                <div className='text-13 text-[#000000] font-[500]'>
                  <span>View all funds</span> <span className='text-[#6A6E6E] font-[400]'>from</span>{' '}
                  <span>{data?.fundDetails?.fundHouse}</span>
                </div>
              </Button>
            </div> */}
      </div>
    </MFAccordion>
  )
}
